"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _httpUtils = require("../http-utils");

var _errorCodes = _interopRequireDefault(require("../error-codes"));

var _uploadOptionsBase = _interopRequireDefault(require("../upload-options-base"));

var _uploadError = _interopRequireDefault(require("../upload-error"));

var _httpResponse = _interopRequireDefault(require("./http-response"));

var _uuid = require("uuid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Invoked when there is an immediate retry error. Handles special cases and adds the
 * error to the given result.
 * @param {Error|string} e The error that occurred.
 * @param {HttpResult} httpResult Result being provided for the current operation.
 */
function handleRetryError(e, httpResult) {
  if (e && e.message && e.message === _errorCodes.default.USER_CANCELLED) {
    throw new _uploadError.default('user cancelled the operation', _errorCodes.default.USER_CANCELLED);
  }

  if (!(0, _httpUtils.isRetryableError)(e)) {
    throw e;
  }

  if (httpResult) {
    httpResult.addRetryError(e);
  }
}
/**
 * Builds an object containing retry options that will be provided to the utility method
 * that submits HTTP requests. The options will include the number of times to retry,
 * the amount of time between retries, and a method to invoke whenever there is an
 * intermediate error.
 *
 * @param {DirectBinaryUploadOptions} uploadOptions Options controlling the upload process.
 * @param {HttpResult} httpResult Result being provided for the current operation. Any
 *   intermediate retry errors will be added to the result.
 */


function getRetryOptions(uploadOptions, httpResult) {
  return {
    retryCount: uploadOptions.getHttpRetryCount(),
    retryDelay: uploadOptions.getHttpRetryDelay(),
    onRetryError: function onRetryError(e) {
      return handleRetryError(e, httpResult);
    }
  };
}
/**
 * Registers a cancel token, which is used to cancel an HTTP request, with
 * a corresponding cancel ID.
 *
 * @param {string} cancelId ID that will be passed to cancel().
 * @param {string} tokenId A unique identifier that can be used to identify
 *  this specific token. Will be used to remove the token when the request
 *  is finished.
 * @param {*} cancelToken Axios token that is used to cancel an request.
 */


function registerCancelId(cancelId, tokenId, cancelToken) {
  if (!this.cancelTokens[cancelId]) {
    this.cancelTokens[cancelId] = [];
  }

  this.cancelTokens[cancelId].push(cancelToken);
}
/**
 * Removes a cancel token that was previously registered using registerCancelId.
 *
 * @param {string} cancelId ID that will be passed to cancel().
 * @param {string} tokenId A unique identifier that can be used to identify
 *  the specific token to remove.
 */


function unregisterCancelId(cancelId, tokenId) {
  if (this.cancelTokens[cancelId]) {
    for (var i = 0; i < this.cancelTokens[cancelId].length; i++) {
      var currTokenId = this.cancelTokens[cancelId][i].tokenId;

      if (tokenId === currTokenId) {
        this.cancelTokens[cancelId].splice(i, 1);
        break;
      }
    }
  }
}
/**
 * Cancels HTTP requests based on event data from DirectBinaryUploadController's
 * 'cancel' event data. Depending on event data, the client will either cancel
 * only those requests whose cancel ID matches the given file name, or cancel
 * all requests if no fileName is given.
 *
 * @param {object} cancelEventData Event data from cancel event.
 */


function cancelFromController(cancelEventData) {
  var targetFilePath = cancelEventData.fileName;

  if (targetFilePath) {
    // use the target file's path as cancel ID and cancel any matches
    this.cancel(targetFilePath);
  } else {
    // no file path, cancel ALL requests
    this.cancelAll();
  }
}
/**
 * Supports submitting and managing in-progress HTTP requests. Features of the
 * client include retrying failed requests, timing request duration, and canceling
 * in-progress requests.
 */


var HttpClient = /*#__PURE__*/function (_UploadOptionsBase) {
  _inherits(HttpClient, _UploadOptionsBase);

  var _super = _createSuper(HttpClient);

  /**
   * Constructs a new instance of an HTTP request client using the given
   * information.
   * @param {object} options General direct binary upload options.
   * @param {DirectBinaryUploadOptions} uploadOptions Options specific to
   *  the current upload.
   */
  function HttpClient(options, uploadOptions) {
    var _this;

    _classCallCheck(this, HttpClient);

    _this = _super.call(this, options, uploadOptions);
    _this.cancelTokens = {};
    _this.cancelledTokens = {};
    _this.allCancelled = false;

    _this.getUploadOptions().getController().on('cancel', cancelFromController.bind(_assertThisInitialized(_this)));

    return _this;
  }
  /**
   * Cancels one or more in-progress request(s) by a cancel ID.
   *
   * @param {string} cancelId All requests with a matching cancelId
   *  will be cancelled.
   */


  _createClass(HttpClient, [{
    key: "cancel",
    value: function cancel(cancelId) {
      if (this.cancelTokens[cancelId]) {
        this.cancelTokens[cancelId].forEach(function (cancelToken) {
          cancelToken.cancel(_errorCodes.default.USER_CANCELLED);
        });
        delete this.cancelTokens[cancelId];
      }

      this.cancelledTokens[cancelId] = true;
    }
    /**
     * Cancels all in-progress requests, regardless of cancel ID.
     */

  }, {
    key: "cancelAll",
    value: function cancelAll() {
      var _this2 = this;

      Object.keys(this.cancelTokens).forEach(function (cancelId) {
        _this2.cancel(cancelId);
      });
      this.allCancelled = true;
    }
    /**
     * Retrieves a value indicating whether a given cancel ID has been
     * used to cancel an in-progress request. Will return true if the
     * individual ID was cancelled, or if all requests were cancelled.
     *
     * @param {string} cancelId ID to check for cancellation.
     * @returns {boolean} True if the ID was cancelled, false otherwise.
     */

  }, {
    key: "isCancelled",
    value: function isCancelled(cancelId) {
      return this.allCancelled || !!this.cancelledTokens[cancelId];
    }
    /**
     * Submits an HTTP request. The client will automatically retry the request if
     * it encounters a retry-able error (i.e. 5xx errors or network-related errors).
     * If the request results in a non-success response then the method will throw an
     * exception containing details of the error.
     *
     * The client also provides support for canceling an in-progress request using
     * its cancel() method.
     *
     * Note that all errors that this method throws will be of type UploadError.
     *
     * @param {HttpRequest} httpRequest Request to submit. Information will be used to initialize
     *  an HTTP request. Note that, if present, the request's getCancelId() can be used with
     *  the cancel() method to cancel this request. In addition, the request will be cancelled
     *  if the ID matches the name of the file in DirectBinaryUploadController's "cancel" event.
     *  Note that the ID doesn't need to be unique to a request - meaning that multiple requests
     *  could be cancelled using a single cancelId.
     * @param {HttpResult} [httpResult] Optional result to which any retry errors will be
     *  added.
     * @returns {HttpResponse} Response to the request, which can be used to retrieve information
     *  from the response.
     */

  }, {
    key: "submit",
    value: function () {
      var _submit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(httpRequest) {
        var httpResult,
            cancelToken,
            tokenId,
            rawResponse,
            _ref,
            isAxiosError,
            _ref$config,
            config,
            _ref$response,
            response,
            url,
            method,
            status,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                httpResult = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                cancelToken = (0, _httpUtils.createCancelToken)();
                tokenId = (0, _uuid.v4)();
                registerCancelId.call(this, httpRequest.getCancelId(), tokenId, cancelToken);
                _context.prev = 4;
                _context.next = 7;
                return (0, _httpUtils.timedRequest)(httpRequest.toJSON(), getRetryOptions(this.getUploadOptions(), httpResult), cancelToken);

              case 7:
                rawResponse = _context.sent;
                return _context.abrupt("return", new _httpResponse.default(this.getOptions(), rawResponse));

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
                _ref = _context.t0 || {}, isAxiosError = _ref.isAxiosError, _ref$config = _ref.config, config = _ref$config === void 0 ? {} : _ref$config, _ref$response = _ref.response, response = _ref$response === void 0 ? {} : _ref$response;

                if (isAxiosError) {
                  url = config.url, method = config.method;
                  status = response.status;
                  this.logError("".concat(method, " ").concat(url, " < failed with status code ").concat(status));
                } else {
                  this.logError('HTTP request failed with error', _context.t0);
                }

                throw _uploadError.default.fromError(_context.t0);

              case 16:
                _context.prev = 16;
                unregisterCancelId.call(this, httpRequest.getCancelId(), tokenId);
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 11, 16, 19]]);
      }));

      function submit(_x) {
        return _submit.apply(this, arguments);
      }

      return submit;
    }()
  }]);

  return HttpClient;
}(_uploadOptionsBase.default);

exports.default = HttpClient;